import { defineStore } from 'pinia'
import _service from '@/service';
import { $BigNumber, bySplit,getPrecision } from '@/utils';

export const useTaskStore = defineStore('task', {
  state: () => ({
    taskFingerShow:false,
  }),
  getters: {
    getTaskFingerShow(state){
      return state.taskFingerShow
    }
  },
  actions: {
    setTaskFingerShow(data:any){
      this.taskFingerShow = data
    }
  },
})
